








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PensionTypeDto } from "@/api/ClientPortalApiClient";

@Component({})
export default class CbxPensionType extends Vue {
  private types: PensionTypeDto[] | null = [];
  private selectedType = new PensionTypeDto();
  public created() {
    this.getAvailableTypes();
  }

  public setSelected(type: PensionTypeDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  public setSelectedName(name: string) {
    if (this.types) {
      this.types.forEach(element => {
        if (element.name === name) {
          this.selectedType = element;
          return;
        }
      });
    }
  }

  public typeSelected(type: PensionTypeDto) {
    this.$emit("pensionTypeSelected", type);
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .pensionType_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
